import Password from './domain/password'
import {isNonBlankString} from './responseRefiners'

export const EMAIL_REGEXP = /^\S+@\S+\.\S+$/

export function validateEmail(email: string) {
  const trimmedEmail = email.trim()
  if (trimmedEmail === '') {
    return 'registration.MentorProfile01_Fail_error4'
  } else if (!EMAIL_REGEXP.test(trimmedEmail)) {
    return 'registration.MentorProfile01_Fail_error6'
  }
  return null
}

export function validatePassword(
  password: string,
  requiredKey: string,
  lengthKey: string
): string | null {
  if (!isNonBlankString(password)) {
    return requiredKey
  }
  if (!Password.isValid(password)) {
    return lengthKey
  }
  return null
}

export function passwordsMatch(repeated: string, password: string): boolean {
  return repeated === password
}
